<template>
  <div>
    <h1 class="text-center mb-3">Deltakere til stede</h1>
    <v-flex xs12>
      <PersonList
        title="Utleier(e)"
        v-model="protocol.saved_values.participants.sellers"
        @update-list="updateFields"
        dialogText="<p>
            Vennligst registrere alle som er til stede på vegne av selger.</p>"
      ></PersonList>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <PersonList
        title="Leietager(e)"
        v-model="protocol.saved_values.participants.buyers"
        @update-list="updateFields"
        dialogText="<p>
            Personer som ikke er registrert som selger eller kjøper, må ha fullmakt for å signere overtagelsesprotokollen.
          </p>
          <p>
            Fullmakt skal foreligge hos representant for selger. Har du med deg fullmakt på overtagelsen, kan du ta et bilde av den ved å klikke på <v-icon>mdi-camera</v-icon>
          </p>"
      ></PersonList>
    </v-flex>
    <ImageUploadBox :images="protocol.saved_values.participants.images" title="Fullmakter:" @update-fields="updateFields"></ImageUploadBox>
    <StepButtons @next-page="next" @previous-page="previous" />
  </div>
</template>

<script>
import step from "../../../mixins/step";
import PersonList from "../../form/PersonList.vue";
export default {
  mixins: [step],
  components: { PersonList },
  methods: {
    next: function() {
      if (this.protocol.saved_values.participants.sellers.length == 0) {
        this.$emit(
          "error",
          "Det må være minst en representant for selger tilstede."
        );
        return false;
      }
      if (this.protocol.saved_values.participants.buyers.length == 0) {
        this.$emit("error", "Det må være minst en kjøper tilstede");
        return false;
      }
      this.$emit("next-page");
    }
  }
};
</script>
